import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { PainelinsumoService } from '../../../services/painelinsumo.service';
import { ToastService } from '../../../services/toast.service';
import { MaterialDeposito } from '../../../types/MaterialDeposito.type';

@Component({
  selector: 'app-insumos-excecao',
  templateUrl: './insumos-excecao.component.html',
  styleUrl: './insumos-excecao.component.css',
  providers: [ConfirmationService]
})
export class InsumosExcecaoComponent {
  loading: boolean = false;
  materiais: MaterialDeposito[] = []

  constructor(private painelInsumoService: PainelinsumoService, private router: Router,
              private toastService: ToastService, private confirmationService: ConfirmationService) {}

  ngOnInit(){
    this.carregarMateriais();
  }

  carregarMateriais(){
    this.loading = true;
    this.materiais = [];

    this.painelInsumoService.getListMaterialDeposito().subscribe({
      next: (data) => {
        this.materiais = data
      },
      error: (error) => {
        this.loading = false;
        this.toastService.erro("Erro", error.error.message);
      },
      complete: () => {
        this.loading = false;
      }
    })
  }

  abreNovoDialog() {
    this.router.navigate(["novo"])
  }

  excluir(id: string){
    this.painelInsumoService.deleteMaterialDeposito(id).subscribe({
      next: () => {
        this.toastService.sucesso("Sucesso", "Material excluído com sucesso");
        this.carregarMateriais();
      },
      error: (value) => {
       this.toastService.erro("Erro", "Erro ao excluir: " + value)
      }
    })
  }

  confirmarExclusao(id: string) {
    this.confirmationService.confirm({
      message: 'Tem certeza de que deseja excluir ?',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.excluir(id);
      }
      });
  }
}
